import { useMemo } from 'react';

import { CartSummaryMap } from '@/components/modules/_shared/CartSummary/maps/CartSummary.map';
import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';

export const useCheckoutSessionCart = () => {
  const { checkoutSessionEntity } = useCheckoutSessionContext();

  const checkoutSession = checkoutSessionEntity?.checkoutSession;

  const cartSummaryData = useMemo(() => {
    if (!checkoutSession) {
      return undefined;
    }
    return CartSummaryMap.fromCheckoutSessionToCartSummaryData(checkoutSession);
  }, [checkoutSession]);

  const downPayment = checkoutSession?.downPayment;
  const discount = cartSummaryData?.totalDiscount;

  const isAutoCart = cartSummaryData ? CartSummaryMap.isSingleAutomobileCart(cartSummaryData) : false;

  return {
    checkoutSessionEntity,
    checkoutSession,
    cartSummaryData,
    downPayment,
    discount,
    isAutoCart,
  };
};
